import { RootState } from "@/app/stores"
import { IUpdateUserProfileRequest, IUser } from "@/shared/api/users"
import { updateUserProfile } from "@/shared/api/users/users"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchFillUserProfile = createAsyncThunk<
    IUser,
    IUpdateUserProfileRequest,
    { state: RootState }
>('fillProfile/fetchFillUserProfile', async (data, thunkAPI) => {
    try {
        const { currentUser } = thunkAPI.getState().fillProfile
        const response = await updateUserProfile(currentUser!.id, data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
